class FeaturedProducts extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-swiper-featured-products]');

    this.swiperOptions = {
      autoplay: false,
      centerInsufficientSlides: true,
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1.8,
      spaceBetween: 25,
      breakpoints: {
        480: {
          slidesPerView: 2.6
        },
        768: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 4
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    }

    // Check if we have extra options on the HTML
    if (this && this.dataset && this.dataset.options) {
      const jsonOptions = JSON.parse(this.dataset.options);

      if (jsonOptions) {
        this.swiperOptions = {
          ...this.swiperOptions,
          ...jsonOptions
        };
      }
    }

    this.init();
  }

  init() {
    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
  }
}

if (!customElements.get('featured-products-swiper')) {
  customElements.define('featured-products-swiper', FeaturedProducts);
}
